import useStore from '../store/store';

const IsPermissionGranted = (permission) => {
    const permissions = useStore.getState().permissions;
    return permissions.includes(permission);
};

export default IsPermissionGranted;
